// V9.25 · Resumo do mês fechado para a direção (mensagem curta, 1 clique no WhatsApp)
import React, { useCallback, useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Badge } from '@/components/ui/badge';
import { toast } from 'sonner';
import { CheckCircle2, MessageCircle, Send } from 'lucide-react';
import api from '@/lib/api';

export const ResumoMesCard = () => {
  const [data, setData] = useState(null);
  const [phone, setPhone] = useState('');

  const load = useCallback(async (tel) => {
    try {
      const { data: d } = await api.get('/fin/ledger/monthly-report',
        { params: { phone: tel || undefined } });
      setData(d);
      if (!tel && d.phone) setPhone(d.phone);
    } catch (_) { /* bloco secundário */ }
  }, []);

  useEffect(() => { load(); }, [load]);

  const enviar = async () => {
    const tel = phone.replace(/\D/g, '');
    if (tel.length < 10) return toast.error('Informe o WhatsApp da direção com DDD.');
    const { data: d } = await api.get('/fin/ledger/monthly-report', { params: { phone: tel } });
    window.open(d.whatsapp_url, '_blank');
    await api.post('/fin/ledger/monthly-report/mark-sent',
      { competencia: d.competencia, phone: tel });
    toast.success(`Resumo de ${d.competencia} aberto no WhatsApp.`);
    load(tel);
  };

  const copiar = async () => {
    await navigator.clipboard.writeText(data?.mensagem || '');
    toast.success('Mensagem copiada.');
  };

  if (!data) return null;

  return (
    <Card className={data.due_now ? 'border-sky-400 bg-sky-50/70' : ''} data-testid="card-resumo-mes">
      <CardHeader className="pb-2 flex flex-row items-start justify-between gap-3 flex-wrap">
        <div>
          <CardTitle className="text-base flex items-center gap-2">
            <MessageCircle className="w-4 h-4" /> Resumo de {data.competencia} para a direção
          </CardTitle>
          <p className="text-xs text-muted-foreground mt-1">
            Mês fechado, em uma mensagem curta. Enviamos por WhatsApp em 1 clique.
          </p>
        </div>
        {data.already_sent ? (
          <Badge variant="outline" className="bg-emerald-100 text-emerald-800 border-emerald-300 gap-1"
            data-testid="resumo-enviado">
            <CheckCircle2 className="w-3 h-3" /> Já enviado
          </Badge>
        ) : data.due_now ? (
          <Badge variant="outline" className="bg-sky-100 text-sky-800 border-sky-300"
            data-testid="resumo-pendente">Pendente deste mês</Badge>
        ) : null}
      </CardHeader>
      <CardContent className="space-y-3">
        <pre className="text-xs sm:text-sm whitespace-pre-wrap rounded-lg border bg-background p-3 font-sans"
          data-testid="resumo-mensagem">{data.mensagem}</pre>
        <div className="flex flex-wrap items-end gap-2">
          <div className="flex-1 min-w-[180px]">
            <label className="text-xs font-bold uppercase text-muted-foreground">WhatsApp da direção</label>
            <Input value={phone} onChange={(e) => setPhone(e.target.value)}
              placeholder="11 99999-9999" data-testid="resumo-telefone" />
          </div>
          <Button onClick={enviar} data-testid="resumo-enviar">
            <Send className="w-4 h-4 mr-1" /> Enviar no WhatsApp
          </Button>
          <Button variant="outline" onClick={copiar} data-testid="resumo-copiar">Copiar texto</Button>
        </div>
        {!!data.phones?.length && (
          <p className="text-xs text-muted-foreground">
            Números recentes: {data.phones.join(' · ')}
            {data.last_sent_competencia && ` · último envio: ${data.last_sent_competencia}`}
          </p>
        )}
      </CardContent>
    </Card>
  );
};

export default ResumoMesCard;
